<fcom-plain-header-area [title]="'oneUpgrade.pageTitle.success' | finLocalization"> </fcom-plain-header-area>

<div class="white-bg pr-small border rounded-large mr-xsmall-b">
  <cms-unstyled-fragment
    *ngIf="getFragment() | async | finLocalization as fragment"
    class="block"
    [contentUrl$]="fragment | finToObservable"
  >
  </cms-unstyled-fragment>
</div>

<fin-section-review class="mr-xsmall-b" [title]="'oneUpgrade.success.feedbackTitle' | finLocalization" [noButton]>
  <ng-container ngProjectAs="content">
    <div class="flex flex--column flex--nowrap">
      <p class="mr-small-b" data-testid="upgrade-survey-promo">
        {{ 'oneUpgrade.success.feedbackClarification' | finLocalization }}
      </p>
      <fcom-button class="open-survey" (clickBtn)="openSurvey()" [text]="'feedback.title' | finLocalization">
      </fcom-button>
      <fin-qualtrics [survey]="survey" [(open)]="surveyOpen"> </fin-qualtrics>
    </div>
  </ng-container>
</fin-section-review>

<div *ngIf="bookingRef$ | async" class="align-right block">
  <fcom-button
    (clickBtn)="redirectToMMB()"
    [text]="'oneUpgrade.success.backToManageBooking' | finLocalization"
    [icon]="{
      name: SvgLibraryIcon.ARROW_RIGHT,
      position: IconPosition.RIGHT,
    }"
  ></fcom-button>
</div>
